import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';
import { SessionFacade } from '@mode/sessions/domain';

export const DowngradedSessionsDomainModule = angular
  .module('downgraded-sessions-domain', [])
  .service('SessionFacade', downgradeInjectable(SessionFacade)).name;
